// framework/src/common/schemas/collections/threads.js
import { z } from "zod";

export const ThreadMemberSchema = z.object({
    participantId:   z.string().describe("userId | agentName | contactId"),
    participantType: z.enum(["user", "agent", "contact"]),
    role:            z.enum(["owner", "member", "observer", "assistant"]).default("member"),
    displayName:     z.string().default(""),
    avatarUrl:       z.string().nullable().optional().default(null),
    // External transport contact fields
    transport:       z.enum(["whatsapp", "telegram", "sms", "email"]).nullable().optional().default(null),
    transportId:     z.string().nullable().optional().default(null),
    addedAt:         z.coerce.date().optional(),
    addedBy:         z.string().nullable().optional().default(null),
});

export const ReadReceiptSchema = z.object({
    participantId:      z.string(),
    lastReadAt:         z.coerce.date(),
    lastReadMessageId:  z.string().nullable().optional().default(null),
});

const ThreadSchema = z.object({
    _id:            z.string().optional().describe("MongoDB ObjectId"),
    subscriptionId: z.string().describe("The subscription this thread belongs to."),
    projectId:      z.string().nullable().optional().default(null),

    // ── Conversation type ─────────────────────────────────────────────────
    type: z.enum(["ai_only", "ai_human", "group", "contact_direct", "contact_group"])
           .default("ai_only"),

    // ── Participants ──────────────────────────────────────────────────────
    members: z.array(ThreadMemberSchema).default([]),

    // ── Group configuration ───────────────────────────────────────────────
    groupName:      z.string().nullable().optional().default(null),
    groupAvatarUrl: z.string().nullable().optional().default(null),
    aiResponseMode: z.enum(["always", "mentioned", "manual"]).default("always"),

    // ── Last message summary (for sidebar preview, avoids extra queries) ──
    lastMessageAt:       z.coerce.date().nullable().optional().default(null),
    lastMessagePreview:  z.string().nullable().optional().default(null),
    lastMessageSenderId: z.string().nullable().optional().default(null),

    // ── Read receipts (embedded per-participant, updated on thread-leave) ─
    readReceipts: z.array(ReadReceiptSchema).default([]),

    title:  z.string().default("New Conversation"),
    status: z.enum(["active", "archived"]).default("active"),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default ThreadSchema;